import { motion } from 'framer-motion';
import { LegacyRef, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa6';
import useUserClickObserver from '../../../hooks/useUserClickObserver';

interface IAcademiaTableSelect {
  options: Array<string>;
  onChangeHandler: (param: any) => void;
}

const AcademiaTableSelect = ({
  options,
  onChangeHandler,
}: IAcademiaTableSelect) => {
  // integration of react hooks here
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [selectValue, setSelectValue] = useState<string>('10');

  // integration of custom hooks here
  const selectRef = useUserClickObserver(setShowOptions);

  // rendering custom table select input field component here
  return (
    <div ref={selectRef as LegacyRef<HTMLDivElement>} className='relative'>
      <div
        onClick={() => setShowOptions((state) => !state)}
        className='bg-base-white w-[130px] rounded-lg px-4 py-2 flex items-center justify-between font-semibold text-legal-dark-blue cursor-pointer active:scale-95 duration-300'
      >
        <p>{selectValue}</p>
        <FaChevronDown
          className={`${showOptions ? 'rotate-180' : 'rotate-0'} duration-300`}
        />
      </div>

      <motion.ul
        initial={{ height: 0 }}
        animate={showOptions ? { height: 'fit-content' } : { height: 0 }}
        className='absolute bg-gray-200 w-full mt-1 rounded-lg overflow-hidden z-20 [&>li:not(:last-child)]:border-b [&>li:not(:last-child)]:border-legal-dark-blue [&>li:not(:last-child)]:border-dashed'
      >
        {options.map((option, index) => (
          <li
            key={index}
            onClick={() => {
              setSelectValue(option);
              setShowOptions(false);
              onChangeHandler(option);
            }}
            className='px-2 py-1 text-center cursor-pointer font-semibold hover:bg-gray-50 hover:text-legal-dark-blue duration-300'
          >
            {option}
          </li>
        ))}
      </motion.ul>
    </div>
  );
};

export default AcademiaTableSelect;
